import { Button } from "@mui/material";
import React, { useState } from "react";
import toast from "react-hot-toast";
import http from "../services/httpService";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { cdt_create_advice } from "../utils/varialbles";

export default function Cdtcreateadvice({ sendValue }) {
  console.log(sendValue);
  const history = useHistory();
  const labels = [
    {
      id: 0,
      name: "Mobile Number",
      type: "mnumber",
      required: true,
    },
    {
      id: 1,
      name: "Total Advised Amount",
      type: "number",
      required: true,
    },
    {
      id: 2,
      name: "Choose Country",
      type: "select",
      required: true,
    },
    {
      id: 3,
      name: "Comments",
      type: "textarea",
      required: true,
    },
  ];

  const [form, setForm] = useState({});

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const [mblError, setMblError] = useState(false);
  const [mblErrorMsg, setMblErrorMsg] = useState(false);
  const [country, setCountry] = useState([]);
  const [name, setName] = useState("");
  const [mblSC, setMblSC] = useState(null);
  // console.log(form);

  const mblregexp = new RegExp(/^[0-9]{10}$/);

  const handleNumber = () => {
    console.log(mblregexp.test(form["mobilenumber"]));
    if (form["mobilenumber"]) {
      // if (mblregexp.test(form["mobilenumber"])) {
      // console.log(true);
      http
        .get(`/validationrequest?mobile=${form["mobilenumber"]}`)
        .then((res) => {
          console.log(res.data.statusCode);
          if (res.data.statusCode === 0) {
            setMblError(true);
            setMblErrorMsg("Successfully verified");
            setCountry(res.data.Data);
            setName(res.data.name);
            setMblSC(res.data.statusCode);
          }
          if (res.data.statusCode === 1) {
            setMblError(true);
            setMblErrorMsg(res.data.error);
          }
        })
        .catch((err) => {
          console.log(err);
        });
      // } else {
      //   if (!mblregexp.test(form["mobilenumber"])) {
      //     setMblError(true);
      //     setMblErrorMsg("Invalid mobile number");
      //   } else {
      //     setMblError(false);
      //   }
      // }
    } else {
      if (!form["mobilenumber"]) {
        setMblError(true);
        setMblErrorMsg("Please enter mobile number");
      } else {
        setMblError(false);
      }
    }
  };

  const sendDetails = {
    mobile: form["mobilenumber"],
    amount: form["advisedamnt"],
    country: form["country"],
    req_type: "e",
    req_comment: form["comments"],
  };

  const createReq = () => {
    if (
      form["advisedamnt"] &&
      form["country"] &&
      form["mobilenumber"] &&
      form["comments"]
    ) {
      http
        .post(`/validationrequest?mobile=${form["mobilenumber"]}`, sendDetails)
        .then((res) => {
          console.log(res.data);
          if (res.data.statusCode === 0) {
            console.log(res.data);
            sendValue();
          }
          if (res.data.statusCode === 1) {
            toast.error(res.data.error);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      toast.error("Manidatory fields are required");
    }
  };

  return (
    <div>
      <div>
        <h1>Name of the customer: {name ? name : ""}</h1>
        <div>
          {labels.map((item, index) => {
            return (
              <div style={{ display: "flex", columnGap: 10 }}>
                <p style={{ width: "200px" }}>
                  {item.name}{" "}
                  {item.required === true ? (
                    <span style={{ color: "red" }}>*</span>
                  ) : (
                    ""
                  )}
                </p>
                <div className="cdtinputs" style={{ marginTop: 10 }}>
                  {item.type === "mnumber" ? (
                    <>
                      <input
                        type="tel"
                        onChange={handleChange}
                        name="mobilenumber"
                      />
                      <Button
                        variant="contained"
                        style={{ marginLeft: 20 }}
                        onClick={handleNumber}
                        disabled={mblSC === 0 ? true : false}
                      >
                        verify Mobile Number
                      </Button>
                      <p style={{ color: mblSC === 0 ? "green" : "red" }}>
                        {mblError ? mblErrorMsg : ""}
                      </p>
                    </>
                  ) : item.type === "number" ? (
                    <input
                      type="number"
                      onChange={handleChange}
                      name="advisedamnt"
                    />
                  ) : item.type === "select" ? (
                    <>
                      <select
                        onChange={handleChange}
                        name="country"
                        disabled={country.length !== 0 ? false : true}
                      >
                        <option value="">Select</option>
                        {country.map((item) => {
                          return (
                            <option value={item.value}>{item.name}</option>
                          );
                        })}
                      </select>
                    </>
                  ) : item.type === "textarea" ? (
                    <textarea
                      rows={3}
                      cols={29}
                      style={{ outline: 0, border: "1px solid #ccc" }}
                      onChange={handleChange}
                      name="comments"
                    ></textarea>
                  ) : null}
                </div>
              </div>
            );
          })}
        </div>
        <Button
          variant="contained"
          style={{ margin: "20px 0" }}
          onClick={createReq}
        >
          Create Request
        </Button>
      </div>
    </div>
  );
}
